import { render, staticRenderFns } from "./edit-postal.vue?vue&type=template&id=9ab8c254&scoped=true&"
import script from "./edit-postal.vue?vue&type=script&lang=js&"
export * from "./edit-postal.vue?vue&type=script&lang=js&"
import style0 from "./edit-postal.vue?vue&type=style&index=0&id=9ab8c254&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab8c254",
  null
  
)

export default component.exports